import { Box, Grid, Theme, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ReactChildren } from '../../interfaces/Common';
import Image from '../../Assets/assetHelper';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    height: '100vh',
    width: '100vw',
    position: 'relative', 
    backgroundColor: theme.palette.KenColors.ClientGrey2,
   
    // backgroundImage: `url(${Image.Images.authBgImg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  },
  formContainer: {
    position: 'fixed',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 2,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100% !important',
    minHeight: '100vh !important',
    width: '100% !important',
    alignItems: 'center',
  },
  copywrite: {
    fontSize: '14px !important',
    fontWeight: '500',
    color: '#8A8A8A',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '10.5px !important',
    },
  },
  loginVector: {
    height: '330px',
    opacity: '0.1',
    [theme.breakpoints.down('md')]: {
      height: '230px',
    },
    [theme.breakpoints.down('sm')]: {
      height: '130px',
    },
  },
  logo: {
    position: 'absolute',
    top: '52%',
    [theme.breakpoints.down('ultraHD')]: { top: '42%',},
    left: '-7%', 
    opacity: '10%',
    width: '661px', 
    height: '661px',
    zIndex: 1, 
  },
}));

const AuthLayout: React.FunctionComponent<ReactChildren> = ({ children }) => {
  const classes = useStyles();

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12}>
        <Box className={classes.formContainer}>{children}</Box>
      </Grid>
      <Box sx={{ position: 'fixed', bottom: '5%', left: '50%', transform: 'translate(-50%, -50%)' }}>
        <Typography className={classes.copywrite}>Turbostart @ 2024</Typography>
      </Box>
      {/* Logo image at the bottom left */}
      <img
        src="https://alumnikenverse.blob.core.windows.net/images/investor-logo.png"
        alt="Investor Logo"
        className={classes.logo}
      />
    </Grid>
  );
};

export default AuthLayout;
